import { useState, useEffect } from "react";
import "./Notification.css";
import NotificationContentSkeleton from "./NotificationContentSkeleton";
import EmptyNotification from "../EmptyStates/EmptyNoti/EmptyNoti";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
export const NotificationComponent = () => {
  return (
    <div className=" notification-card card">
      <div className="border-bottom ">
        <h5 className="card-title dtt-hfs ">Skill Alerts</h5>
      </div>
        <NewNotifications />
    </div>
  );
};

export const NewNotifications = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const formattedDate = dateString.split('T')[0];
    const [year, month, day] = formattedDate.split('-');

  // Convert to MM-DD-YYYY format
  const formatDate = `${month}-${day}-${year}`;
  return formatDate;
  };

  useEffect(() => {
    setTimeout(() => {
      fetchNotifications();
    }, 1000);
  }, []);

  const fetchNotifications = async () => {
    const secretkeyUser = process.env.REACT_APP_USER_KEY;
    var parsedObject;
    const data = localStorage.getItem("userData");
    if (data) {
      const bytes = CryptoJS.AES.decrypt(data, secretkeyUser);
      const decryptedJsonString = bytes.toString(CryptoJS.enc.Utf8);
      parsedObject = JSON.parse(decryptedJsonString);
    } else {
      console.error("No data found.");
    }
    try {
      const requestBody = {
        batchId : null
      };
      
      const response = await fetch(
        `${process.env.REACT_APP_API_URL_DOTNET}/Dashboard/skillAlert`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${parsedObject["token"]}`,
          },
          body: JSON.stringify(requestBody), // Convert your request body to JSON
        }
      );
      
      const data = await response.json();
      setNotifications(data.result);
      setIsLoading(false);
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/error/statusCode=401");
      }
      if (error.response.status === 400) {
        navigate("/error/statusCode=400");
      }
      if (error.response.status === 500) {
        navigate("/error/statusCode=500");
      }
      if (error.response.status === 404) {
        navigate("/error/statusCode=404");
      }
      console.error("Error occurred while fetching notificatons:", error);
    }
  };
  return (
    <>
      {isLoading ? (
        <>
        <div className="notification-cover">
          <NotificationContentSkeleton />
          <NotificationContentSkeleton />
          <NotificationContentSkeleton />
          <NotificationContentSkeleton />
          <NotificationContentSkeleton />
        </div>
        </>
      ) : notifications?.length === 0 ? (
        <div className="notification-cover-empty">
        <EmptyNotification />
         </div>
      ) : (
        <div className="notification-cover skill-added-scroll">
        {notifications?.map((user) => {
          return (
            <>
              <div className="notification-wrapper">
                <div className="image-wrapper mt-1">
                  <div className="image-box">
                    <img
                      src={user.techimage}
                      width={32}
                      alt=""
                    />
                  </div>
                </div>
                <div className="text-wrapper mt-3">
                  <p key={user.userId} className="m-0">
                    <b>
                      {user.firstName} {user.lastName}
                    </b>{" "}
                    has achieved {user.levelName.toLowerCase()}
                    <b> skill </b> on <b>{user.techName}</b>
                  </p>
                  <p className="m-0 date-wrapper">{formatDate(user.examDate)} </p>
                </div>
              </div>
            </>
          );
        })}
         </div>
      )}
    </>
  );
};
